import styled from 'styled-components'

export const StyledPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;

  > .pagination-container {
    padding: 20px 10px;

    > ul {
      //UL Reset
      margin: 0;
      padding: 0;
      text-indent: 0;
      list-style-type: none;

      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      color: #707070;

      > li {
        &.selected {
          box-shadow: 0 5px 5px -5px rgba($primary, 0.15), 0 10px 10px -5px rgba($primary, 0.15),
            0 15px 15px -5px rgba($primary, 0.15), 0 20px 20px -5px rgba($primary, 0.15);
          cursor: pointer;
          transition: background 0.25s ease;
          transition: color 0.25s ease;
          :hover {
            cursor: pointer;
            transform: scale(1);
          }

          a {
            padding: 5px 15px;
            cursor: pointer;
            border-radius: 999px;
            color: ${props => props.theme.buttonColor};
            background: ${props => props.theme.buttonFill};
            :hover {
              cursor: pointer;
              text-decoration: none;
              transform: scale(1);
            }
          }
        }

        :not(:first-child):not(:last-child) {
          margin-left: 5px;
          margin-right: 5px;
        }

        > a {
          padding: 5px 15px;
          color: #707070;
          :hover {
            cursor: pointer;
          }
          :focus {
            outline: none;
          }
        }

        :hover {
          cursor: pointer;
          transform: scale(1.2);
        }

        &.disabled {
          > a {
            color: #909090;
            :hover {
              cursor: default;
              text-decoration: none;
            }
          }

          :hover {
            cursor: default;
          }
        }
      }
    }
  }

  > .rpp-selector-container {
    margin-left: 10px;
    .form-group {
      display: flex;
      align-items: center;
      width: 100%;
      margin: 0;

      > label {
        width: auto;
        margin-right: 10px;
      }

      .activity-form-dropdown {
        width: 150px;
        color: #707070;
        .activity-form-dropdown__control {
          border-radius: 0;
          border-width: 0;
          .activity-form-dropdown__single-value {
            color: #707070;
          }
        }
        .activity-form-dropdown__control--is-focused {
          border-width: 1px;
          border-radius: 0;
          border-color: #386071 !important;
          box-shadow: none;
        }
      }
      .activity-form-dropdown__menu {
        border-radius: 0;
        .activity-form-dropdown__option--is-focused {
          background-color: #38607140;
        }
        .activity-form-dropdown__option--is-selected {
          background-color: #386071;
        }
        .activity-form-dropdown__menu-list {
          padding: 0;
        }
      }

      .activity-form-dropdown {
        .activity-form-dropdown__control {
          border: 1px solid hsl(0, 0%, 80%);
        }
      }
    }
  }
`
